import React, { useState, useRef, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import Marquee from "react-fast-marquee";

// --- ASSET IMPORTS FROM ALL FILES ---

// HomePage Assets
import HomeBackground from './assets/HomeBackground.png';
import Quotesicon from './assets/Quotesicon.png';
import Homeblackhoodie from './assets/Homeblackhoodie.png';

// AboutPage Assets
import AboutBackground from './assets/AboutBackground.jpg';
import FrontendBackground from './assets/FrontendBackground.png';
import BackendBackground from './assets/BackendBackground.jpg';
import UiUxBackground from './assets/UiUxBackground.jpg';

// ResumePage Assets
import LeetcodeIcon from './assets/LeetcodeIcon.svg';
import HackerIcon from './assets/HackerIcon.svg';
import ResumeArrow from './assets/ResumeArrow.svg';
import CodeCheficon from './assets/CodeCheficon.png';
import codewarsicon from './assets/codewarsicon.png';
import HoverRedCircle from './assets/HoverRedCircle.png';

// ProjectsPage Assets
import AmazonClone from './assets/AmazonClone.png';
import TodoList from './assets/TodoList.png';
import Snakegame from './assets/Snakegame.png';
import CloudExpenser from './assets/CloudExpenser.png';
import OnlineExaminationSystem from './assets/OnlineExaminationSystem.png';

// AchievementsPage Assets
import NPTELCertificate from './assets/NPTELCertificate.png';
import Thiran360Internship from './assets/Thiran360Internship.png';
import RejolaInternship from './assets/RejolaInternship.png';
import VirtualInternship from './assets/VirtualInternship.png';
import PythonCourseeraCertificate from './assets/PythonCourseeraCertificate.png';
import LearnathonCertificate from './assets/LearnathonCertificate.png';
import CloudComputing from './assets/CloudComputing.png';
import AdobeHackathon from './assets/AdobeHackathon.png';
import DesignCoursera from './assets/DesignCoursera.png';
import AICoursera from './assets/AICoursera.png';
import Nptel1 from './assets/Nptel1.png';
import Nptel3 from './assets/Nptel3.png';

// ContactPage (Footer) Assets
import LinkedinIcon from './assets/LinkedinIcon.svg';
import GithubIcon from './assets/GithubIcon.svg';
import GmailIcon from './assets/GmailIcon.svg';
import WhatsappIcon from './assets/WhatsappIcon.svg';
import EmailAddressContactIcon from './assets/EmailAddressContactIcon.svg';
import UpArrowContactIcon from './assets/UpArrowContactIcon.svg';


//==================================================================
// --- 1. HOME PAGE SECTION ---
//==================================================================

const HomePage = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <style>
        {`
          #home {
            min-height: 110vh;
            background-image: linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.1)), url(${HomeBackground});
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
            color: white;
            display: flex;
            flex-direction: column;
            padding: 0 2%;
            box-sizing: border-box;
            position: relative;
            background-color: #000;
          }

          #home .navbar {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 15px 0;
            width: 99%;
            height: 45px;
            max-width: 1400px;
            margin: 25px auto 0 auto;
            z-index: 10;
            border: 1px solid rgba(255, 255, 255, 0.5);
            border-radius: 50px;
          }

          #home .nav-links {
            list-style: none; display: flex; width: 100%; margin: 0; padding: 0 20px;
            align-items: center; justify-content: space-between;
          }
          #home .nav-links li { display: flex; }
          #home .nav-links li a, #home .nav-links li span {
            color: #ffffff; text-decoration: none; font-weight: 500; font-size: -1rem;
            letter-spacing: 0.5px; padding: 8px 15px; transition: color 0.3s ease, background-color 0.3s ease;
            position: relative; display: block; border-radius: 20px;
          }
          #home .nav-links li a.active, #home .nav-links li a:hover {
            color: white; background-color: #FF4D4D;
          }
          #home .portfolio-title {
            font-family: 'Times New Roman', sans-serif; font-size: 2.4rem; font-weight: 900;
            letter-spacing: 5px; margin: 0 2vw; color: #ffffff !important;
          }

          #home .hero-section {
            text-align: center; margin-top: 5vh; z-index: 1; width: 100%;
            transition: opacity 0.6s ease-in-out, transform 0.6s ease-in-out;
          }
          #home .hero-section h1, #home .hero-section h2 {
            font-family: 'Urbanist', sans-serif; margin: 0; line-height: 1.2;
          }
          #home .hero-section h2 { font-size: clamp(2rem, 4.5vw, 4rem); font-weight: 900; }
          #home .hero-section h1 { font-size: clamp(2.5rem, 6vw, 6rem); font-weight: 700; letter-spacing: 1px; }
          #home .hero-section .name { color: #FF4D4D; }

          #home .profile-image-container {
            position: absolute; bottom: -4%; left: 50%; transform: translateX(-50%);
            z-index: 0; line-height: 0;
          }
          #home .profile-image-container img {
            max-width: 600px; height: 520px; display: block;
            transition: transform 0.6s ease-in-out;
          }
          #home .bottom-section {
            position: absolute; bottom: 5%; left: 10%; right: 10%;
            display: flex; align-items: flex-end; justify-content: space-between; z-index: 1;
          }
          #home .quote-text {
            font-size: clamp(1.2rem, 1.3vw, 1.3rem); line-height: 1.9; max-width: 475px;
            position: relative; padding-left: 70px; font-weight: 500; flex-basis: 50%;
            flex-grow: 1; margin-left: -140px; margin-bottom: 180px;
            transition: transform 0.6s ease-in-out;
          }
          #home .quote-icon-img { position: absolute; left: 0; top: -10px; width: 50px; height: 55px; opacity: 0.9; }
          #home .projects-count {
            text-align: right; padding-bottom: 10px; transition: transform 0.6s ease-in-out;
          }
          #home .projects-count .stars {
            color: #FF4D4D; font-size: clamp(1rem, 1.5vw, 1.8rem); margin-top: -280px;
            margin-right: -90px; letter-spacing: 4px;
          }
          #home .projects-count .count {
            font-size: clamp(1.5rem, 3vw, 3.5rem); position: relative; font-weight: 900;
            color: #FFFFFF; display: block; line-height: 1; margin-right: -80px; font-family: 'Urbanist', sans-serif;
          }
          #home .projects-count .label {
            font-size: clamp(1rem, 1.8vw, 2rem); display: block; position: relative;
            color: white; font-weight: 500; margin-right: -90px;
          }
          #home.is-hovered .hero-section { opacity: 0; transform: translateY(-50px); pointer-events: none; }
          #home.is-hovered .quote-text, #home.is-hovered .projects-count { transform: translateY(-35vh); }
          #home.is-hovered .profile-image-container img { transform: scale(1.02); }

          @media (max-width: 1200px) {
            #home .navbar { width: 95%; }
            #home .portfolio-title { font-size: 1.8rem; }
            #home .nav-links li a { font-size: 0.9rem; }
          }
          @media (max-width: 992px) {
            #home .portfolio-title { font-size: 1.5rem; }
            #home .nav-links li a { padding: 8px 10px; font-size: 0.8rem; }
            #home .hero-section { padding-left: 0; text-align: center; margin-top: 10vh; margin-bottom: 5vh; }
            #home .profile-image-container { position: relative; transform: none; left: auto; bottom: auto; text-align: center; order: 2; margin-bottom: 5vh; }
            #home .profile-image-container img { max-width: 60%; margin: 0 auto; }
            #home .bottom-section { position: relative; flex-direction: column; align-items: center; text-align: center; gap: 50px; margin-top: 0; bottom: auto; left: auto; right: auto; }
            #home .projects-count { text-align: center; }
            #home .quote-text { padding-left: 0; max-width: 80%; }
            #home .quote-icon-img { position: static; display: block; margin: 0 auto 15px auto; width: 40px; }
            #home.is-hovered .hero-section, #home.is-hovered .quote-text, #home.is-hovered .projects-count, #home.is-hovered .profile-image-container img { transform: none; }
            #home.is-hovered .hero-section { opacity: 1; }
          }
          @media (max-width: 768px) {
            #home .nav-links { flex-wrap: wrap; justify-content: center; row-gap: 10px; }
            #home .portfolio-title { order: -1; width: 100%; text-align: center; }
          }
        `}
      </style>
      <section id="home" className={isHovered ? 'is-hovered' : ''}>
        <nav className="navbar">
          <ul className="nav-links">
            <li><a href="#home" className="active">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#resume">Resume</a></li>
            <li><span className="portfolio-title">PORTFOLIO</span></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#achievements">Achievements</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>

        <main className="hero-section">
          <h2>I'm <span className="name">Ravinder Singh,</span></h2>
          <h1>Versatile Developer</h1>
        </main>
        
        <div 
          className="profile-image-container"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <img src={Homeblackhoodie} alt="Ravinder Singh Profile" />
        </div>

        <footer className="bottom-section">
          <div className="quote-text">
            <img src={Quotesicon} alt="Quote" className="quote-icon-img" />
            Ravinder is a forward-thinking full-stack developer who combines problem-solving with creativity to deliver seamless user experiences.
          </div>
          <div className="projects-count">
            <div className="stars">★★★★★</div>
            <span className="count">30+</span>
            <span className="label">Projects</span>
          </div>
        </footer>
      </section>
    </>
  );
};

//==================================================================
// --- 2. ABOUT PAGE SECTION ---
//==================================================================

const AboutPage = () => {
  const ArrowIcon = () => (
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path className="arrow-initial" d="M7 17l9.5-9.5M17 17V7H7" />
      <path className="arrow-hover" d="M5 12h14m-7-7l7 7-7 7" />
    </svg>
  );

  return (
    <>
      <style>
        {`
          #about {
            width: 100%; min-height: 100vh;
            background-image: linear-gradient(rgba(13, 17, 23, 0.9), rgba(13, 17, 23, 0.9)), url(${AboutBackground});
            background-size: cover; background-position: center center; 
            background-attachment: scroll;
            color: white; padding: 0 2%; box-sizing: border-box; display: flex;
            flex-direction: column; align-items: center; background-color: #0d1117;
          }
          /* UPDATED: Standardized Navbar */
          #about .navbar {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 15px 0;
            width: 99%;
            height: 45px;
            max-width: 1400px;
            margin: 25px auto 0 auto;
            z-index: 10;
            border: 1px solid rgba(255, 255, 255, 0.5);
            border-radius: 50px;
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
          }
          #about .nav-links {
            list-style: none; display: flex; width: 100%; margin: 0; padding: 0 20px;
            align-items: center; justify-content: space-between;
          }
          #about .nav-links li { display: flex; }
          #about .nav-links li a, #about .nav-links li span {
            color: #ffffff; text-decoration: none; font-weight: 500; font-size: -1rem;
            letter-spacing: 0.5px; padding: 8px 15px; transition: color 0.3s ease, background-color 0.3s ease;
            position: relative; display: block; border-radius: 20px;
          }
          #about .nav-links li a.active, #about .nav-links li a:hover {
            color: white; background-color: #FF4D4D;
          }
          #about .portfolio-title {
            font-family: 'Times New Roman', sans-serif; font-size: 2.4rem; font-weight: 900;
            letter-spacing: 5px; margin: 0 2vw; color: #ffffff !important;
          }

          #about .about-content {
            width: 100%; max-width: 1600px; padding: 80px 0; display: flex;
            flex-direction: column; align-items: center;
          }
          #about .about-header-section {
            display: flex; align-items: center; gap: 50px; width: 100%; margin-bottom: 80px;
          }
          #about .about-header {
            font-family: 'Urbanist', sans-serif; font-size: 3.5rem; font-weight: 900;
            color: #007AC5; flex-basis: 25%; text-align: left; margin-left: 20px; margin-top: -20px;
          }
          #about .about-description {
            font-size: 1.1rem; line-height: 1.9; color: #c0c0c0; flex-basis: 75%;
            text-align: left; max-width: 1560px; margin-top: -20px; margin-left: -90px;
          }
          #about .cards-container {
            display: grid; grid-template-columns: repeat(3, 1fr); gap: 40px; width: 100%;
          }
          #about .card {
            background-color: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 35px; padding: 25px; height: 450px; backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px); transition: transform 0.3s ease, background-color 0.3s ease;
            display: flex; flex-direction: column;
          }
          #about .card:hover { transform: translateY(-10px); background-color: rgba(255, 255, 255, 0.1); }
          #about .card-title-container { padding: 0 10px; }
          #about .card-title {
            font-family: 'Urbanist', sans-serif; font-size: 1.8rem; font-weight: 700; margin: 0; color: #f0f0f0;
          }
          #about .card-divider {
            height: 2px; width: calc(100% + 70px); position: relative; left: -10px;
            background-color: rgba(255, 255, 255, 0.15); margin: 15px -25px;
          }
          #about .card-body { flex-grow: 1; position: relative; }
          #about .paddy-layer { position: absolute; border-radius: 25px; }
          #about .paddy-1 { background-color: #726F6F; top: 0; left: 0; width: calc(100% - 20px); height: calc(100% - 20px); z-index: 1; }
          #about .paddy-2 { background-color: #BAB2B2; top: 10px; left: 10px; width: calc(100% - 20px); height: calc(100% - 20px); z-index: 2; }
          #about .card-image-layer {
            position: absolute; top: 20px; left: 20px; width: calc(100% - 20px); height: calc(100% - 20px);
            border-radius: 25px; background-size: cover; background-position: center; overflow: hidden; z-index: 3;
          }
          #about .arrow-wrapper {
            position: absolute; bottom: 10px; right: 10px; width: 90px; height: 90px;
            background-color: #364457; border-radius: 50%; display: flex; align-items: center;
            justify-content: center; cursor: pointer; transition: transform 0.3s ease, background-color 0.3s ease; z-index: 4;
          }
          #about .arrow-initial, #about .arrow-hover { transition: opacity 0.3s ease; }
          #about .arrow-hover { opacity: 0; position: absolute; }
          #about .card:hover .arrow-initial { opacity: 0; }
          #about .card:hover .arrow-hover { opacity: 1; }
          #about .card:hover .arrow-wrapper { background-color: #D83133; transform: scale(1.1); }

          @media (max-width: 1200px) {
            #about .about-header-section { flex-direction: column; text-align: center; gap: 20px; margin-bottom: 60px; }
            #about .about-header, #about .about-description { text-align: center; margin: 0; flex-basis: auto; }
            #about .about-description { max-width: 90%; }
            #about .cards-container { grid-template-columns: 1fr; gap: 50px; width: 90%; max-width: 550px; margin: 0 auto; }
          }
          @media (max-width: 768px) {
            #about .navbar { padding: 15px; height: auto; border-radius: 30px; margin-top: 25px; }
            #about .nav-links { flex-wrap: wrap; justify-content: center; row-gap: 10px; padding: 0 10px; }
            #about .nav-links li a, #about .nav-links li span { font-size: 0.9rem; padding: 6px 12px; }
            #about .portfolio-title { order: -1; width: 100%; text-align: center; font-size: 1.8rem; letter-spacing: 4px; margin-bottom: 10px; }
            #about .about-content { padding: 60px 0; }
            #about .about-header { font-size: 2.8rem; }
            #about .about-description { font-size: 1rem; line-height: 1.7; max-width: 100%; }
            #about .cards-container { width: 100%; max-width: none; }
          }
          @media (max-width: 480px) {
            #about .portfolio-title { font-size: 1.5rem; }
            #about .about-header { font-size: 2.2rem; }
            #about .card { height: 400px; padding: 20px; border-radius: 25px; }
            #about .arrow-wrapper { width: 75px; height: 75px; }
            #about .arrow-wrapper svg { width: 50px; height: 50px; }
          }
        `}
      </style>
      <section id="about">
        <nav className="navbar">
          <ul className="nav-links">
            <li><a href="#home">Home</a></li>
            <li><a href="#about" className="active">About</a></li>
            <li><a href="#resume">Resume</a></li>
            <li><span className="portfolio-title">PORTFOLIO</span></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#achievements">Achievements</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>

        <div className="about-content">
          <div className="about-header-section">
            <h2 className="about-header">ABOUT</h2>
            <p className="about-description">
              As a passionate innovator and a Computer Science and Engineering student at K.S.R. College of Engineering, my core drive is to build impactful digital solutions. I specialize in full-stack development, leveraging powerful technologies like React.js for dynamic front-ends and Python with Flask for robust back-ends. I enjoy architecting applications that merge creative UI/UX with robust functionality. I actively enhance my development workflow using AI-powered tools and have hands-on experience deploying scalable applications on cloud platforms. My vision is to contribute meaningfully to the evolving world of technology.
            </p>
          </div>

          <div className="cards-container">
            <div className="card">
              <div className="card-title-container"><h3 className="card-title">UI/UX Design</h3><div className="card-divider"></div></div>
              <div className="card-body">
                <div className="paddy-layer paddy-1"></div><div className="paddy-layer paddy-2"></div>
                <div className="card-image-layer" style={{ backgroundImage: `url(${UiUxBackground})` }}></div>
                <div className="arrow-wrapper"><ArrowIcon /></div>
              </div>
            </div>
            <div className="card">
              <div className="card-title-container"><h3 className="card-title">Front End Developer</h3><div className="card-divider"></div></div>
              <div className="card-body">
                <div className="paddy-layer paddy-1"></div><div className="paddy-layer paddy-2"></div>
                <div className="card-image-layer" style={{ backgroundImage: `url(${FrontendBackground})` }}></div>
                <div className="arrow-wrapper"><ArrowIcon /></div>
              </div>
            </div>
            <div className="card">
              <div className="card-title-container"><h3 className="card-title">Back End Developer</h3><div className="card-divider"></div></div>
              <div className="card-body">
                <div className="paddy-layer paddy-1"></div><div className="paddy-layer paddy-2"></div>
                <div className="card-image-layer" style={{ backgroundImage: `url(${BackendBackground})` }}></div>
                <div className="arrow-wrapper"><ArrowIcon /></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

//==================================================================
// --- 3. RESUME PAGE SECTION ---
//==================================================================

const PortfolioResume = () => {
  const [activeButton, setActiveButton] = useState('preview');

  return (
    <>
      <style>{`
        #resume { 
          background-color: #FFFFFF; 
          color: #333;
          padding-top: 25px; 
          padding-bottom: 40px;
        }
        #resume .portfolio-container { max-width: 1600px; margin: 0 auto; padding: 0 5%; box-sizing: border-box; }
        
        /* UPDATED: Standardized Navbar */
        #resume .navbar {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 15px 0;
            width: 99%;
            height: 45px;
            max-width: 1400px;
            margin: 0 auto;
            z-index: 10;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 50px;
            background-color: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
        }
        #resume .nav-links {
            list-style: none; display: flex; width: 100%; margin: 0; padding: 0 20px;
            align-items: center; justify-content: space-between;
        }
        #resume .nav-links li { display: flex; }
        #resume .nav-links li a, #resume .nav-links li span {
            /* Text color changed for visibility on light background */
            color: #333; 
            text-decoration: none; font-weight: 500; font-size: -1rem;
            letter-spacing: 0.5px; padding: 8px 15px; transition: color 0.3s ease, background-color 0.3s ease;
            position: relative; display: block; border-radius: 20px;
        }
        #resume .nav-links li a.active, #resume .nav-links li a:hover {
            color: white; background-color: #A03535;
        }
        #resume .portfolio-title {
            font-family: 'Times New Roman', sans-serif; font-size: 2.4rem; font-weight: 900;
            letter-spacing: 5px; margin: 0 2vw; color: #333 !important;
        }

        #resume .resume-section { display: flex; align-items: center; gap: 4rem; margin-top: 4rem; }
        #resume .profile-image-container { flex: 1; max-width: 450px; position: relative; }
        #resume .profile-image {
          width: 100%; height: auto; object-fit: cover; margin-top: -130px; margin-left:-30px;
          position: relative; z-index: 2;
        }
        #resume .profile-image-hover-circle {
          position: absolute; top: -120px; left: -55px; width: 500px; height: 500px;
          opacity: 0; transition: opacity 0.3s ease-in-out; pointer-events: none; z-index: 1;
        }
        #resume .profile-image-container:hover .profile-image-hover-circle { opacity: 1; }
        #resume .resume-content { flex: 1.5; }
        #resume .resume-content h1 {
          font-size: 3rem; font-weight: 700; color: #A03535; margin-bottom: 30px; margin-top:-10px;
        }
        #resume .resume-content p.description {
          font-size: 1.2rem; line-height: 2; color: #555; margin-bottom: 1.5rem;
        }
        #resume .stats { display: flex; gap: 22rem; margin-bottom: 2.5rem; }
        #resume .stat-item h2 { font-size: 2.5rem; font-weight: 700; margin-left:0px; }
        #resume .stat-item p { font-size: 1rem; color: #777; margin-top:-20px; }
        #resume .action-buttons { display: flex; }
        #resume .btn-toggle-container {
          display: inline-flex; align-items: center; border: 2px solid #ddd; border-radius: 50px;
          padding: 10px; background-color: #fff; width: 500px; 
        }
        #resume .btn-toggle {
          padding: 0.7rem 2rem; text-decoration: none; font-weight: 600; font-size: 1rem;
          display: inline-flex; align-items: center; justify-content: center; gap: .75rem;
          transition: all 0.3s ease-in-out; border: none; border-radius: 50px;
          cursor: pointer; white-space: nowrap; flex-grow: 1;
        }
        #resume .btn-toggle.btn-active { background-color: #A03535; color: white; }
        #resume .btn-toggle.btn-inactive { background-color: transparent; color: #333; }
        #resume .btn-active img { width: 16px; height: 16px; filter: brightness(0) invert(1); }
        #resume .coding-profiles {
          margin-top: 4rem; padding-bottom: 2rem; display: flex; align-items: center; gap: 15.88rem;
        }
        #resume .profile-link { display: flex; align-items: center; gap: 1.2rem; text-decoration: none; color: #333; }
        #resume .profile-link img { height: 40px; }
        #resume .profile-link span { font-weight: 800; }

        @media (max-width: 1200px) {
          #resume .resume-section { flex-direction: column; text-align: center; gap: 2rem; margin-top: 2rem; }
          #resume .profile-image-container { max-width: 400px; width: 100%; }
          #resume .profile-image, #resume .profile-image-hover-circle { margin: 0; }
          #resume .resume-content h1 { margin-top: 0; }
          #resume .stats { gap: 10rem; justify-content: center; }
          #resume .action-buttons, #resume .coding-profiles { justify-content: center; }
          #resume .coding-profiles { margin-top: 1rem; }
        }
        @media (max-width: 992px) {
          #resume .stats { flex-direction: column; gap: 1.5rem; align-items: center; margin-bottom: 2rem; }
          #resume .stat-item p { margin-top: -15px; }
        }
        @media (max-width: 768px) {
          #resume .portfolio-container { padding: 0 4%; }
          #resume .navbar { height: auto; padding: 15px; margin-top: 0; }
          #resume .nav-links { flex-wrap: wrap; justify-content: center; row-gap: 10px; }
          #resume .portfolio-title { order: -1; width: 100%; text-align: center; font-size: 1.8rem; margin-bottom: 10px; }
          #resume .nav-links li a, #resume .nav-links li span { font-size: 0.9rem; }
          #resume .resume-content h1 { font-size: 2.5rem; }
          #resume .resume-content p.description { font-size: 1rem; line-height: 1.8; }
          #resume .btn-toggle-container { width: 100%; max-width: 500px; padding: 5px; }
          #resume .btn-toggle { font-size: 0.9rem; padding: 0.6rem 1rem; }
          #resume .coding-profiles { flex-direction: column; gap: 2rem; }
        }
        @media (max-width: 480px) {
          #resume .portfolio-title { font-size: 1.5rem; }
          #resume .resume-content h1 { font-size: 2.2rem; }
          #resume .stat-item h2 { font-size: 2rem; }
        }
      `}</style>

      <section id="resume">
        <nav className="navbar">
            <ul className="nav-links">
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#resume" className="active">Resume</a></li>
                <li><span className="portfolio-title">PORTFOLIO</span></li>
                <li><a href="#projects">Projects</a></li>
                <li><a href="#achievements">Achievements</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul>
        </nav>
        <div className="portfolio-container">
            <main>
                <div className="resume-section">
                    <div className="profile-image-container">
                        <img src={Homeblackhoodie} alt="Profile" className="profile-image" />
                        <img src={HoverRedCircle} alt="Hover Circle" className="profile-image-hover-circle" />
                    </div>
                    <div className="resume-content">
                        <h1>Resume</h1>
                        <p className="description">
                            I am a full-stack developer and Computer Science undergraduate specializing in web and software solutions, with proficiency in Python, Java, React, and Flask. My hands-on experience from internships at Thiran30 Ai and Rejola Company includes building a complete expense tracking application. During my internship, I developed responsive frontends using HTML, CSS, and JavaScript connected to a Flask backend for real-time data processing. My work is further demonstrated through key projects like an Amazon Clone and a Java-based Online Examination System. I have also been recognized with an Elite + Silver Certificate for my performance in Cloud Computing from NPTEL.
                        </p>
                        <div className="stats">
                            <div className="stat-item"><h2>30+</h2><p>Project</p></div>
                            <div className="stat-item"><h2>10+</h2><p>Project Completed</p></div>
                        </div>
                        <div className="action-buttons">
                            <div className="btn-toggle-container" onMouseLeave={() => setActiveButton('preview')}>
                                <a href="https://drive.google.com/file/d/1YDfEo4cGkSoC4ISNvJxFfYgLUf6EWnxg/preview" target="_blank" rel="noopener noreferrer" className={`btn-toggle ${activeButton === 'preview' ? 'btn-active' : 'btn-inactive'}`} onMouseEnter={() => setActiveButton('preview')}>
                                    Preview
                                    {activeButton === 'preview' && <img src={ResumeArrow} alt="arrow icon" />}
                                </a>
                                <a href="https://drive.google.com/file/d/1YDfEo4cGkSoC4ISNvJxFfYgLUf6EWnxg/view?usp=sharing" className={`btn-toggle ${activeButton === 'download' ? 'btn-active' : 'btn-inactive'}`} onMouseEnter={() => setActiveButton('download')}>
                                    Download
                                    {activeButton === 'download' && <img src={ResumeArrow} alt="arrow icon" />}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="coding-profiles">
                    <a href="https://www.hackerrank.com/profile/singhravinder961" target="_blank" rel="noopener noreferrer" className="profile-link"><img src={HackerIcon} alt="HackerRank" /><span>HackerRanker</span></a>
                    <a href="https://leetcode.com/u/DivamSingh/" target="_blank" rel="noopener noreferrer" className="profile-link"><img src={LeetcodeIcon} alt="LeetCode" /><span>LeetCode</span></a>
                    <a href="https://www.codechef.com/users/ravinder_9680" target="_blank" rel="noopener noreferrer" className="profile-link"><img src={CodeCheficon} alt="CodeChef" /><span>CodeChef</span></a>
                    <a href="https://www.codewars.com/users/ravinder_9680" target="_blank" rel="noopener noreferrer" className="profile-link"><img src={codewarsicon} alt="Codewars" /><span>Codewars</span></a>
                </footer>
            </main>
        </div>
      </section>
    </>
  );
};

//==================================================================
// --- 4. PROJECTS PAGE SECTION ---
//==================================================================

const PortfolioProjects = () => {
    // --- Data for the projects with your GitHub links ---
    const projects = [
      {
        title: 'Amazon Clone',
        image: AmazonClone,
        tag: 'Amazon',
        githubLink: 'https://github.com/Ravinder16162020/AmazonClone',
      },
      {
        title: 'To-Do List',
        image: TodoList,
        tag: 'To-do List',
        githubLink: 'https://github.com/Ravinder16162020/todo-list-app',
      },
      {
        title: 'Snake Game',
        image: Snakegame,
        tag: 'Snake',
        githubLink: 'https://github.com/Ravinder16162020/Snake',
      },
      {
        title: 'Cloud Expenser',
        image: CloudExpenser,
        tag: 'Cloud Expenser',
        githubLink: 'https://github.com/Ravinder16162020/CloudExpenser',
      },
      {
        title: 'Online Examination System',
        image: OnlineExaminationSystem,
        tag: 'Online Examination',
        githubLink: 'https://github.com/Ravinder16162020/OnlineExaminationSystem',
      },
    ];

    // Default "external link" icon
    const ArrowOutIcon = () => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#fff' }}>
        <line x1="7" y1="17" x2="17" y2="7"></line>
        <polyline points="7 7 17 7 17 17"></polyline>
      </svg>
    );

    // "Right arrow" icon for hover state
    const ArrowRightIcon = () => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#fff' }}>
        <line x1="5" y1="12" x2="19" y2="12"></line>
        <polyline points="12 5 19 12 12 19"></polyline>
      </svg>
    );

    // --- State and Ref for scroll tracking ---
    const [activeIndex, setActiveIndex] = useState(0);
    const scrollContainerRef = useRef(null);
  
    // --- Effect to handle scroll events ---
    useEffect(() => {
      const handleScroll = () => {
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer) {
          const scrollLeft = scrollContainer.scrollLeft;
          // Assuming all cards have roughly the same width
          const cardWidth = scrollContainer.children[0].children[0].offsetWidth;
          
          // Calculate the index of the card closest to the left edge
          const newIndex = Math.round(scrollLeft / cardWidth);
          setActiveIndex(newIndex);
        }
      };
  
      const scrollContainer = scrollContainerRef.current;
      if (scrollContainer) {
        scrollContainer.addEventListener('scroll', handleScroll);
      }
  
      // Cleanup function to remove the event listener
      return () => {
        if (scrollContainer) {
          scrollContainer.removeEventListener('scroll', handleScroll);
        }
      };
    }, []); // Empty dependency array ensures this runs only once on mount
  
    return (
      <>
        <style>{`
          /* --- General and Navbar Styles --- */
          #projects {
            background-color: #FFFFFF;
          }
          
          #projects .portfolio-body {
            display: flex;
            justify-content: center;
            padding: 0rem;
            box-sizing: border-box;
          }
  
          #projects .portfolio-container {
            width: 100%;
            max-width: 1400px;
            margin: 0 auto;
          }
  
          #projects .navbar {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 15px 0;
            height: 45px;
            width: 110%;
            max-width: 1400px;
            margin: 20px auto ;
            
            z-index: 10;
            background-color: rgba(255, 255, 255, 0.7);
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 50px;
            backdrop-filter: blur(10px);
          }
  
          #projects .nav-links {
            list-style: none;
            display: flex;
            width: 100%;
            margin: 0;
            padding: 0 20px;
            align-items: center;
            justify-content: space-between;
          }
  
          #projects .nav-links li {
            display: flex;
          }
  
          #projects .nav-links li a, #projects .nav-links li span {
            color: #333;
            text-decoration: none;
            font-weight: 500;
            padding: 8px 15px;
            border-radius: 20px;
            transition: color 0.3s ease, background-color 0.3s ease;
          }
  
          #projects .nav-links li a:not(.active):hover {
            color: white;
            background-color: #A03535;
          }
  
          #projects .nav-links li a.active {
            color: white;
            background-color: #A03535;
          }
  
          #projects .portfolio-title-span {
            font-family: 'Times New Roman', sans-serif;
            font-size: 2.4rem;
            font-weight: 900;
            letter-spacing: 5px;
            margin: 0 2vw;
            color: #333 !important;
            background-color: transparent !important;
          }
  
          /* --- Projects Section Styles --- */
          #projects .projects-section {
            padding: 3rem 0;
            margin-top: 60px;
          }
  
          #projects .projects-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2rem;
          }
  
          #projects .projects-header-title h2 {
            font-size: 2.5rem;
            font-weight: 700;
            margin-top: -65px;
            color: #111;
          }
  
          #projects .projects-header-title h3 {
            font-size: 3.5rem;
            font-weight: 700;
            color: #A03535;
            margin-top: -30px;
          }
          
          #projects .see-all-btn {
            background-color: #A03535;
            color: white;
            border: none;
            padding: 0.8rem 1.8rem;
            border-radius: 50px;
            font-size: 1rem;
            font-weight: 500;
            cursor: pointer;
            transition: background-color 0.3s ease;
            margin-top:-150px;
          }
          
          #projects .see-all-btn:hover {
            background-color: #7a1a1a;
          }
          
          /* --- Horizontal Scroll Container --- */
          #projects .scroll-container {
            overflow-x: auto;
            scroll-behavior: smooth;
            scrollbar-width: none;
            -ms-overflow-style: none;
            margin-top: -40px;
          }
          
          #projects .scroll-container::-webkit-scrollbar {
            display: none;
          }
          
          #projects .scroll-track {
            display: flex;
            gap: 2rem;
            padding-bottom: 1rem;
          }
  
          #projects .project-card {
            flex: 0 0 48%;
            box-sizing: border-box;
            position: relative;
          }
          
          #projects .project-card img {
            width: 100%; /* UPDATED: Changed from fixed width to 100% */
            height: 400px;
            object-fit: cover; /* ADDED: Ensures image covers space without distortion */
            border-radius: 12px;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
            display: block;
          }
          
          /* --- GitHub Link Styles --- */
          #projects .github-link {
            position: absolute;
            top: 1rem;
            right: 1rem;
            z-index: 2;
            background-color: #4A5568; /* Default grey color */
            backdrop-filter: blur(5px);
            border-radius: 50%;
            width: 44px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            transition: transform 0.2s ease-out, background-color 0.2s ease-out;
          }
  
          #projects .github-link:hover {
            transform: scale(1.1);
            background-color: #A03535; /* Red hover color */
          }
          
          /* --- Arrow Icon Visibility Control --- */
          #projects .github-link .arrow-right {
            display: none;
          }
          #projects .github-link:hover .arrow-out {
            display: none;
          }
          #projects .github-link:hover .arrow-right {
            display: block;
          }
  
          #projects .project-title {
            position: absolute;
            bottom: 1.5rem;
            left: 1.5rem;
            color: white;
            background-color: rgba(40, 39, 39, 0.2);
            padding: 0.5rem 1rem;
            border-radius: 8px;
            font-size: 1.75rem;
            font-weight: 600;
            margin-left:-20px;
            margin-bottom: -15px;
          }
          
          /* --- Scroll Indicator Dots --- */
          #projects .scroll-indicator-dots {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            margin-top: 2rem;
          }
          #projects .scroll-dot {
            height: 10px;
            width: 10px;
            background-color: #D1D5DB; /* Silver color */
            border-radius: 50%;
            transition: all 0.3s ease;
          }
          #projects .scroll-dot.active {
            background-color: #A03535; /* Red color */
            width: 30px;
            border-radius: 5px;
          }
  
          /* --- Project Tags --- */
          #projects .project-tags {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 1rem;
            margin-top: 3rem;
          }
  
          #projects .tag-btn {
            background-color: #e9ecef;
            border: none;
            border-radius: 50px;
            padding: 0.7rem 1.5rem;
            font-size: 1rem;
            font-weight: 500;
            cursor: pointer;
            transition: background-color 0.3s ease, color 0.3s ease;
          }
          
          #projects .tag-btn:hover {
            background-color: #d1d5db;
          }
  
          /* --- Responsiveness --- */
          
          /* For Tablets */
          @media (max-width: 992px) { 
            #projects .project-card { flex: 0 0 60%; }
            #projects .projects-header-title h2 { font-size: 2rem; }
            #projects .projects-header-title h3 { font-size: 3rem; }
          }
          
          /* For Mobile Phones */
          @media (max-width: 768px) {
            #projects .portfolio-body { padding: 1rem; }
            #projects .navbar { height: auto; padding: 15px; margin-top: 25px; width: 95%; }
            #projects .nav-links { flex-wrap: wrap; justify-content: center; row-gap: 10px; }
            #projects .portfolio-title-span { order: -1; width: 100%; text-align: center; font-size: 1.8rem; margin-bottom: 10px; }
            #projects .nav-links li a, #projects .nav-links li span { font-size: 0.9rem; }
            
            #projects .projects-section { margin-top: 30px; }
            #projects .projects-header { flex-direction: column; text-align: center; gap: 1rem; }
            #projects .projects-header-title h2 {
              font-size: 1.5rem;
              margin-top: 0; /* UPDATED: Reset negative margin for better flow */
            }
            #projects .projects-header-title h3 {
              font-size: 2.2rem;
              margin-top: -5px; /* UPDATED: Reduced negative margin */
            }
            #projects .see-all-btn {
              margin-top: 1rem; /* UPDATED: Removed negative margin */
              padding: 0.6rem 1.4rem;
              font-size: 0.9rem;
            }
            
            #projects .scroll-track { gap: 1rem; }
            #projects .project-card { flex: 0 0 90%; } /* UPDATED: Increased width for single-column feel */
            #projects .project-card img { height: 250px; } /* UPDATED: Reduced image height for mobile */
            #projects .project-title { font-size: 1.2rem; bottom: 1rem; left: 1rem; }
            #projects .project-tags { margin-top: 2rem; gap: 0.5rem; }
            #projects .tag-btn { font-size: 0.9rem; padding: 0.5rem 1rem; }
          }
        `}</style>
        <section id="projects">
            <div className="portfolio-body">
                <div className="portfolio-container">
                <nav className="navbar">
                    <ul className="nav-links">
                    <li><a href="#home">Home</a></li>
                    <li><a href="#about">About</a></li>
                    <li><a href="#resume">Resume</a></li>
                    <li><span className="portfolio-title-span">PORTFOLIO</span></li>
                    <li><a href="#projects" className="active">Projects</a></li>
                    <li><a href="#achievements">Achievements</a></li>
                    <li><a href="#contact">Contact</a></li>
                    </ul>
                </nav>
    
                <main className="projects-section">
                    <div className="projects-header">
                    <div className="projects-header-title">
                        <h2>Exploring my journey through</h2>
                        <h3>Projects</h3>
                    </div>
                    <button className="see-all-btn">See All</button>
                    </div>
        
                    {/* --- MODIFIED: Added ref to scroll container --- */}
                    <div className="scroll-container" ref={scrollContainerRef}>
                    <div className="scroll-track">
                        {projects.map((project, index) => (
                        <div className="project-card" key={index}>
                            <a href={project.githubLink} target="_blank" rel="noopener noreferrer" className="github-link" aria-label={`View ${project.title} on GitHub`}>
                            <span className="arrow-out"><ArrowOutIcon /></span>
                            <span className="arrow-right"><ArrowRightIcon /></span>
                            </a>
                            <img src={project.image} alt={project.title} />
                            <h4 className="project-title">{project.title}</h4>
                        </div>
                        ))}
                    </div>
                    </div>
        
                    {/* --- MODIFIED: Dots are now rendered dynamically --- */}
                    <div className="scroll-indicator-dots">
                    {projects.map((_, index) => (
                        <span
                        key={index}
                        className={`scroll-dot ${index === activeIndex ? 'active' : ''}`}
                        ></span>
                    ))}
                    </div>
        
                    <div className="project-tags">
                    {projects.map((project, index) => (
                        <button className="tag-btn" key={index}>{project.tag}</button>
                    ))}
                    </div>
                </main>
                </div>
            </div>
        </section>
      </>
    );
};

//==================================================================
// --- 5. ACHIEVEMENTS PAGE SECTION ---
//==================================================================

const AchievementsPage = () => {
    const certificates = [
      { 
        id: 1, 
        image: NPTELCertificate, 
        alt: "NPTEL Certificate", 
        className: "cert-nptel-main", 
        label: "NPTEL",
        description: "Successfully completed the 12-week NPTEL course on Cloud Computing from IIT Kharagpur, earning an Elite certificate with a score of 77%. Demonstrated a perfect score on all online assignments (25/25)."
      },
      { 
        id: 2, 
        image: Thiran360Internship, 
        alt: "Thiran360 Internship", 
        className: "cert-thiran360", 
        label: "Internship",
        description: "Completed a hands-on internship focused on practical cloud computing applications. Contributed to projects by applying knowledge of infrastructure, deployment models, and virtualization."
      },
      { 
        id: 3, 
        image: RejolaInternship, 
        alt: "Rejola Internship", 
        className: "cert-rejola", 
        label: "Internship",
        description: "Gained practical experience in software development methodologies during this internship, contributing to a team-based project."
      },
      { 
        id: 4, 
        image: VirtualInternship, 
        alt: "Virtual Internship", 
        className: "cert-virtual-internship", 
        label: "Internship",
        description: "Participated in a virtual internship program, developing skills in remote collaboration and project management."
      },
      { 
        id: 5, 
        image: PythonCourseeraCertificate, 
        alt: "Coursera Python Certificate", 
        className: "cert-python-coursera", 
        label: "Coursera",
        description: "Mastered Python programming fundamentals through this comprehensive Coursera course, including data structures and APIs."
      },
      { 
        id: 6, 
        image: LearnathonCertificate, 
        alt: "Learnathon Certificate", 
        className: "cert-learnathon", 
        label: "Learnathon",
        description: "Achieved certification in a competitive Learnathon, demonstrating rapid learning and problem-solving abilities in a new technology stack."
      },
      { 
        id: 7, 
        image: CloudComputing, 
        alt: "Cloud Computing Certificate", 
        className: "cert-cloud-computing", 
        label: "Cloud Computing",
        description: "Completed a foundational course in Cloud Computing, covering core concepts of IaaS, PaaS, and SaaS."
      },
      { 
        id: 8, 
        image: AdobeHackathon, 
        alt: "Adobe Hackathon Certificate", 
        className: "cert-adobe-hackathon", 
        label: "Hackathon",
        description: "Participated in the Adobe Hackathon, collaborating in a team to build a prototype solution within a 24-hour timeframe."
      },
      { 
        id: 9, 
        image: DesignCoursera, 
        alt: "Design Coursera Certificate", 
        className: "cert-design-coursera", 
        label: "Coursera",
        description: "Completed a Coursera specialization in UI/UX design principles, learning about user-centered design and prototyping."
      },
      { 
        id: 10, 
        image: AICoursera, 
        alt: "AI Coursera Certificate", 
        className: "cert-ai-coursera", 
        label: "Coursera",
        description: "Gained a strong understanding of Artificial Intelligence concepts, including machine learning and neural networks, via this Coursera course."
      },
      { 
        id: 11, 
        image: Nptel1, 
        alt: "NPTEL Certificate 1", 
        className: "cert-nptel-1", 
        label: "NPTEL",
        description: "Another prestigious NPTEL certification showcasing expertise in a core computer science subject."
      },
      { 
        id: 12, 
        image: Nptel3, 
        alt: "NPTEL Certificate 3", 
        className: "cert-nptel-3", 
        label: "NPTEL",
        description: "Further NPTEL certification, highlighting a continued commitment to advanced learning and skill development."
      },
    ];
  
    return (
      <>
        <style>{`
          /* --- General and Navbar Styles --- */
          #achievements {
            background-color: #FFFFFF;
            color: #333;
          }
  
          #achievements .portfolio-container {
            max-width: 1600px;
            margin: 0 auto;
            padding: 0 5%;
            box-sizing: border-box;
          }
  
          #achievements .navbar {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 15px 0;
            height: 45px;
            width: 110%; /* Use percentage for flexibility */
            max-width: 1400px;
            margin: 20px auto ;
            margin-left: -20px;

            z-index: 10;
            background-color: rgba(255, 255, 255, 0.7);
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 50px;
            backdrop-filter: blur(10px);
          }
  
          #achievements .nav-links {
            list-style: none;
            display: flex;
            width: 100%;
            margin: 0;
            padding: 0 25px;
            align-items: center;
            justify-content: space-between;
          }
  
          #achievements .nav-links li {
            display: flex;
          }
  
          #achievements .nav-links li a, #achievements .nav-links li span {
            color: #333;
            text-decoration: none;
            font-weight: 500;
            font-size: -1rem;
            letter-spacing: 0.5px;
            padding: 8px 15px;
            border-radius: 20px;
            transition: color 0.3s ease, background-color 0.3s ease;
          }
  
          #achievements .nav-links li a:not(.active):hover {
            color: white;
            background-color: #A03535;
          }
  
          #achievements .nav-links li a.active {
            color: white;
            background-color: #A03535;
          }
  
          #achievements .portfolio-title {
            font-family: 'Times New Roman', sans-serif;
            font-size: 2.4rem;
            font-weight: 900;
            letter-spacing: 5px;
            margin: 0 2vw;
            color: #333 !important;
          }
  
          /* --- Achievements Section Styles --- */
          #achievements .achievements-section {
            width: 100%;
            margin-top: 60px;
          }
  
          #achievements .achievements-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;
            flex-wrap: wrap; /* Allow wrapping on small screens */
          }
  
          #achievements .achievements-title {
            font-size: 48px;
            color: #000;
            position: relative;
            display: inline-block;
            padding-bottom: 10px;
            font-weight: 700;
            margin-top: -20px;
          }
  
          #achievements .achievements-title span {
            color: #A03535;
          }
  
          #achievements .achievements-title::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 30%;
            height: 4px;
            background-color: #A03535;
          }
  
          #achievements .see-all-button {
            background-color: #982121;
            color: #fff;
            border: none;
            padding: 12px 30px;
            border-radius: 25px;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            margin-top:-20px;
            transition: background-color 0.3s;
          }
  
          #achievements .see-all-button:hover {
            background-color: #7a1a1a;
          }
  
          /* --- Certificate and Marquee Styles --- */
          #achievements .marquee-container {
            padding: 20px 0;
            width: 1500px; /* Use viewport width to span the full screen */
           
            margin-left: -70px;
            
          }
  
          #achievements .certificate-wrapper {
            margin: 0 25px;
            position: relative;
            overflow: hidden;
            border-radius: 8px;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
            -webkit-transform: translateZ(0);
          }
  
          #achievements .certificate-image {
            display: block;
            object-fit: cover;
            border-radius: 8px;
          }
  
          #achievements .certificate-label {
            position: absolute;
            bottom: 15px;
            left: 15px;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            padding: 6px 12px;
            border-radius: 5px;
            font-size: 0.9rem;
            font-weight: 500;
            z-index: 2;
            transition: opacity 0.3s ease;
            pointer-events: none;
          }
  
          #achievements .certificate-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            height: 45%;
            width: 100%;
            background: linear-gradient(to top, rgba(220, 220, 220, 1), rgba(240, 240, 240, 0.85));
            backdrop-filter: blur(2px);
            color: #333;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 15px;
            box-sizing: border-box;
            opacity: 0;
            transform: translateY(100%);
            transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
            z-index: 3;
          }
  
          #achievements .certificate-overlay p {
            margin: 0;
            font-size: 0.9rem;
            text-align: center;
            line-height: 1.5;
          }
  
          /* --- Hover Effects --- */
          #achievements .certificate-wrapper:hover .certificate-overlay {
            opacity: 1;
            transform: translateY(0);
          }
  
          #achievements .certificate-wrapper:hover .certificate-label {
            opacity: 0;
          }
  
          /* --- Base Certificate Image Sizing --- */
          .cert-nptel-main, .cert-thiran360, .cert-rejola, .cert-virtual-internship,
          .cert-python-coursera, .cert-learnathon, .cert-cloud-computing, .cert-adobe-hackathon,
          .cert-design-coursera, .cert-ai-coursera, .cert-nptel-1, .cert-nptel-3 {
            width: 570px;  
            height: 430px;
          }
  
          /* --- Filter Buttons --- */
          #achievements .filter-buttons {
            display: flex;
            justify-content: center;
            flex-wrap: wrap; /* Allow buttons to wrap on smaller screens */
            gap: 20px;
            margin-top: 40px;
            margin-bottom: 30px;
          }
  
          #achievements .filter-btn {
            background-color: #e0e0e0;
            color: #333;
            border: none;
            padding: 12px 30px;
            border-radius: 25px;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            transition: background-color 0.3s;
          }
  
          #achievements .filter-btn:hover {
            background-color: #c7c7c7;
          }
  
          /* --- Responsive Design --- */
          
          /* For Laptops */
          @media (max-width: 1200px) {
            .cert-nptel-main, .cert-thiran360, .cert-rejola, .cert-virtual-internship,
            .cert-python-coursera, .cert-learnathon, .cert-cloud-computing, .cert-adobe-hackathon,
            .cert-design-coursera, .cert-ai-coursera, .cert-nptel-1, .cert-nptel-3 {
              width: 400px;
              height: 280px;
            }
          }
  
          /* For Tablets */
          @media (max-width: 992px) {
             .cert-nptel-main, .cert-thiran360, .cert-rejola, .cert-virtual-internship,
            .cert-python-coursera, .cert-learnathon, .cert-cloud-computing, .cert-adobe-hackathon,
            .cert-design-coursera, .cert-ai-coursera, .cert-nptel-1, .cert-nptel-3 {
              width: 350px;
              height: 245px;
            }
            #achievements .achievements-title {
              font-size: 40px;
            }
          }
  
          /* For Mobile Devices */
          @media (max-width: 768px) {
            #achievements .navbar {
              height: auto;
              padding: 15px;
              margin-top: 25px;
              width: 95%;
            }
            #achievements .nav-links {
              flex-wrap: wrap;
              justify-content: center;
              row-gap: 10px;
            }
            #achievements .portfolio-title {
              order: -1;
              width: 100%;
              text-align: center;
              font-size: 1.8rem;
              margin-bottom: 10px;
            }
            #achievements .nav-links li a, #achievements .nav-links li span {
              font-size: 0.9rem;
            }
  
            #achievements .achievements-header {
              flex-direction: column; /* Stack title and button */
              align-items: center;
              gap: 20px;
              text-align: center;
            }
  
            #achievements .achievements-title {
              font-size: 36px;
              margin-top: 0;
            }
  
            #achievements .see-all-button {
              margin-top: 0;
            }
  
            .cert-nptel-main, .cert-thiran360, .cert-rejola, .cert-virtual-internship,
            .cert-python-coursera, .cert-learnathon, .cert-cloud-computing, .cert-adobe-hackathon,
            .cert-design-coursera, .cert-ai-coursera, .cert-nptel-1, .cert-nptel-3 {
              width: 320px;
              height: 224px;
            }
          }
  
          /* For Small Mobile Devices */
          @media (max-width: 576px) {
            #achievements .portfolio-container {
              padding: 0 3%;
            }
            
            #achievements .nav-links li a, #achievements .nav-links li span {
              font-size: 0.8rem;
              padding: 6px 10px;
            }
            
            #achievements .achievements-title {
              font-size: 28px;
            }
            
            #achievements .see-all-button, #achievements .filter-btn {
              font-size: 14px;
              padding: 10px 25px;
            }
            
            .cert-nptel-main, .cert-thiran360, .cert-rejola, .cert-virtual-internship,
            .cert-python-coursera, .cert-learnathon, .cert-cloud-computing, .cert-adobe-hackathon,
            .cert-design-coursera, .cert-ai-coursera, .cert-nptel-1, .cert-nptel-3 {
              width: 280px;
              height: 196px;
            }
            
            #achievements .certificate-wrapper {
              margin: 0 15px;
            }
  
            #achievements .certificate-overlay p {
              font-size: 0.8rem;
            }
          }
        `}</style>
        
        <section id="achievements">
            <div className="portfolio-container">
                <nav className="navbar">
                <ul className="nav-links">
                    <li><a href="#home">Home</a></li>
                    <li><a href="#about">About</a></li>
                    <li><a href="#resume">Resume</a></li>
                    <li><span className="portfolio-title">PORTFOLIO</span></li>
                    <li><a href="#projects">Projects</a></li>
                    <li><a href="#achievements" className="active">Achievements</a></li>
                    <li><a href="#contact">Contact</a></li>
                </ul>
                </nav>

                <main className="achievements-section">
                <div className="achievements-header">
                    <h1 className="achievements-title">My <span>Achievements</span></h1>
                    <button className="see-all-button">See All</button>
                </div>

                <div className="marquee-container">
                    <Marquee pauseOnHover={true} speed={80}>
                    {certificates.map((cert) => (
                        <div key={cert.id} className="certificate-wrapper">
                        <img
                            src={cert.image}
                            alt={cert.alt}
                            className={`certificate-image ${cert.className}`}
                        />
                        <div className="certificate-label">{cert.label}</div>
                        <div className="certificate-overlay">
                            <p>{cert.description}</p>
                        </div>
                        </div>
                    ))}
                    </Marquee>
                </div>
                
                <div className="filter-buttons">
                    <button className="filter-btn">NPTEL</button>
                    <button className="filter-btn">Internship</button>
                    <button className="filter-btn">Coursera</button>
                    <button className="filter-btn">Hackathon</button>
                    <button className="filter-btn">Courses</button>
                </div>
                </main>
            </div>
        </section>
      </>
    );
};

//==================================================================
// --- 6. CONTACT PAGE SECTION (FOOTER) ---
//==================================================================

const ContactPage = () => {
    // State to hold the email input value
    const [email, setEmail] = useState('');
  
    // Function to handle form submission
    const handleSubmit = (e) => {
      // Prevent the default form refresh behavior
      e.preventDefault();
  
      // Basic email validation
      if (!email || !/\S+@\S+\.\S+/.test(email)) {
        alert('Please enter a valid email address.');
        return;
      }
  
      // --- EmailJS Configuration ---
      const serviceID = 'service_06t0ejk';
      const templateID = 'template_cvw1hf4';
      const publicKey = 'SavUYpPW23VZeASH-'; 
  
      // Object containing the dynamic data for your email template
      const templateParams = {
        from_email: email,
      };
  
      // Send the email using EmailJS
      emailjs.send(serviceID, templateID, templateParams, publicKey)
        .then((response) => {
          console.log('SUCCESS!', response.status, response.text);
          alert('Thank you for subscribing! I have received your email.');
          setEmail(''); // Clear the input field on success
        })
        .catch((err) => {
          console.error('FAILED...', err);
          alert('Failed to send email. Please try again later.');
        });
    };
    
    const styles = `
      /* --- Base Styles (Desktop First) --- */
      .footer-container {
        background-color: #1a1a1a;
        color: #ffffff;
        font-family: 'Poppins', sans-serif;
        padding: 60px 5% 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
      }
  
      .footer-top-section {
        width: 100%;
        max-width: 1200px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 40px;
      }
  
      .footer-title {
        font-size: 4rem;
        font-weight: 700;
        margin-left: -80px;
        margin-top: -10px;
      }
  
      .back-to-top-button {
        background-color: #fff;
        border-radius: 50%;
        width: 100px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: background-color 0.3s ease;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        margin-top:-40px;
        margin-right:-50px;
      }
  
      .back-to-top-button:hover {
        background-color: #444444;
      }
  
      .back-to-top-button img {
        width: 90px;
        height: 90px;
      }
  
      .footer-divider {
        width: 100%;
        max-width: 1400px;
        border-bottom: 2px solid #333333;
        margin: 40px 0;
        margin-top: -40px;
      }
  
      .footer-main-content {
        width: 100%;
        max-width: 1200px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 30px;
        margin-left: 160px;
      }
  
      .footer-about, .footer-navigation, .footer-contact-info, .footer-newsletter {
        flex: 1;
        min-width: 250px;
        margin-bottom: 20px;
      }
  
      .footer-about {
        max-width: 400px;
      }
  
      .footer-about p {
        font-size: 0.95rem;
        line-height: 1.6;
        color: #fff;
        margin-bottom: 20px;
        text-align: left;
        margin-left:-160px;
      }
  
      .footer-social-icons {
        display: flex;
        gap: 45px;
        justify-content: flex-start;
        margin-left:-155px;
      }
  
      .footer-social-icons a img {
        width: 30px;
        height: 30px;
        transition: transform 0.3s ease;
      }
  
      .footer-social-icons a img:hover {
        transform: translateY(-3px);
      }
  
      .footer-column-title, .footer-column-titles, .footer-column-titless {
        font-size: 1.1rem;
        font-weight: 600;
        margin-bottom: 20px;
        margin-top:-10px;
        color: #c72c41;
        text-align: left;
      }
  
      .footer-column-titles {
        margin-left: 80px;
      }
  
      .footer-column-titless {
        margin-left:-40px;
      }
  
      .footer-navigation ul {
        list-style: none;
        padding: 0;
        text-align: left;
        margin-left:80px;
      }
  
      .footer-contact-info ul {
        list-style: none;
        padding: 0;
        margin-left:-40px;
      }
  
      .footer-navigation ul li, .footer-contact-info ul li {
        margin-bottom: 10px;
      }
  
      .footer-navigation ul li a, .footer-contact-info ul li a {
        color: #b0b0b0;
        text-decoration: none;
        font-size: 0.95rem;
        transition: color 0.3s ease;
      }
  
      .footer-navigation ul li a:hover, .footer-contact-info ul li a:hover {
        color: #ffffff;
      }
  
      .footer-newsletter .email-input-wrapper {
        display: flex;
        width: 100%;
        max-width: 280px;
        background-color: #ffffff;
        border-radius: 8px;
        overflow: hidden;
        margin-top: 10px;
      }
  
      .footer-newsletter .email-input {
        flex-grow: 1;
        border: none;
        padding: 12px 15px;
        font-size: 0.95rem;
        color: #333333;
        background-color: transparent;
        outline: none;
      }
  
      .footer-newsletter .email-input::placeholder {
        color: #888888;
      }
  
      .footer-newsletter .submit-button {
        background-color: #c72c41;
        border: none;
        padding: 12px 18px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: background-color 0.3s ease;
      }
  
      .footer-newsletter .submit-button:hover {
        background-color: #a72436;
      }
  
      .footer-newsletter .submit-button .send-icon {
        width: 20px;
        height: 20px;
      }
  
      .footer-bottom {
        width: 100%;
        max-width: 1400px;
        border-top: 1px solid #333333;
        padding-top: 25px;
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 15px;
        font-size: 0.9rem;
        color: #b0b0b0;
      }
  
      .footer-bottom a {
        color: #b0b0b0;
        text-decoration: none;
        transition: color 0.3s ease;
      }
  
      .footer-bottom a:hover {
        color: #ffffff;
      }
  
      .footer-bottom-links {
        display: flex;
        gap: 20px;
      }
      
      /* --- Tablet and Mobile Styles --- */
      @media (max-width: 992px) {
        /* Reset specific desktop margins that cause overflow on smaller screens */
        .footer-title, 
        .back-to-top-button, 
        .footer-main-content, 
        .footer-about p, 
        .footer-social-icons,
        .footer-navigation ul, 
        .footer-contact-info ul,
        .footer-column-titles,
        .footer-column-titless {
          margin-left: 0;
          margin-right: 0;
        }
  
        .footer-main-content, .footer-about p, .footer-social-icons {
          padding-left: 0;
          padding-right: 0;
        }
      }
  
  
      /* --- Tablet View --- */
      @media (max-width: 768px) {
        .footer-top-section, .footer-main-content, .footer-bottom, .footer-bottom-links {
          flex-direction: column;
          align-items: center; /* Center items when stacked */
          text-align: center;
        }
        .footer-top-section, .footer-bottom {
          gap: 20px;
        }
        .footer-title {
          font-size: 3rem; /* Slightly smaller title for tablets */
        }
        .footer-about, .footer-navigation, .footer-contact-info, .footer-newsletter {
          min-width: unset;
          width: 90%;
          max-width: 450px;
          align-items: center; /* Center content within each column */
        }
        .footer-about p {
          text-align: center;
        }
        .footer-social-icons, .footer-navigation ul, .footer-contact-info ul, .footer-column-title, .footer-column-titles, .footer-column-titless {
          justify-content: center;
          text-align: center;
        }
        .footer-newsletter .email-input-wrapper {
          margin-left: auto;
          margin-right: auto;
          max-width: 100%;
        }
        .footer-bottom-links {
          gap: 15px;
        }
      }
  
      /* --- Mobile View --- */
      @media (max-width: 480px) {
        .footer-title {
          font-size: 2.2rem;
        }
        .back-to-top-button {
          width: 60px;
          height: 60px;
        }
        .back-to-top-button img {
          width: 45px;
          height: 45px;
        }
        .footer-newsletter .email-input-wrapper {
          flex-direction: column;
          border-radius: 8px; /* Maintain border radius */
        }
         .footer-newsletter .email-input {
          border-bottom: 1px solid #ddd;
          border-radius: 8px 8px 0 0;
        }
        .footer-newsletter .submit-button {
          width: 100%;
          border-radius: 0 0 8px 8px; /* Match wrapper radius */
        }
      }
    `;
  
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };
  
    return (
      <>
        <style>{styles}</style>
        <section id="contact">
            <footer className="footer-container">
                <div className="footer-top-section">
                <h2 className="footer-title">Lets Connect there</h2>
                <div className="back-to-top-button" onClick={scrollToTop} aria-label="Back to top">
                    <img src={UpArrowContactIcon} alt="Up arrow" />
                </div>
                </div>

                <div className="footer-divider"></div>

                <div className="footer-main-content">
                <div className="footer-about">
                    <p>
                    Thank you for taking the time to review my portfolio and learn
                    more about my work. I am passionate about building efficient,
                    user-centric software and I am open to discussing opportunities
                    where I can contribute my skills in full-stack development,
                    backend engineering with Java & Python, and intuitive UI/UX
                    design. Please feel free to reach out via email or LinkedIn, as I look
                    forward to the possibility of connecting with you.
                    </p>
                    <div className="footer-social-icons">
                    <a href="https://www.linkedin.com/in/ravinder-singh-9b1147292" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                        <img src={LinkedinIcon} alt="LinkedIn" />
                    </a>
                    <a href="https://github.com/Ravinder16162020" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                        <img src={GithubIcon} alt="GitHub" />
                    </a>
                    {/* UPDATED: Added a pre-filled subject line to the mailto link */}
                    <a href="mailto:singhravinder9680@gmail.com?subject=Inquiry%20from%20Portfolio" aria-label="Gmail">
                        <img src={GmailIcon} alt="Gmail" />
                    </a>
                    <a href="https://wa.me/+917006540818" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                        <img src={WhatsappIcon} alt="WhatsApp" />
                    </a>
                    </div>
                </div>

                <div className="footer-navigation">
                    <h3 className="footer-column-titles">Navigation</h3>
                    <ul>
                    <li><a href="#home">Home</a></li>
                    <li><a href="#about">About</a></li>
                    <li><a href="#resume">Resume</a></li>
                    <li><a href="#project">Project</a></li>
                    <li><a href="#achievements">Achievements</a></li>
                    </ul>
                </div>

                <div className="footer-contact-info">
                    <h3 className="footer-column-titless">Contact</h3>
                    <ul>
                    <li><a href="tel:+917006540818">+91 7006540818</a></li>
                    {/* UPDATED: Added a pre-filled subject line to the mailto link */}
                    <li><a href="mailto:singhravinder9680@gmail.com?subject=Inquiry%20from%20Portfolio">singhravinder9680@gmail.com</a></li>
                    {/* UPDATED: Corrected the LinkedIn URL for consistency */}
                    <li><a href="https://www.linkedin.com/in/ravinder-singh-9b1147292" target="_blank" rel="noopener noreferrer">https://www.linkedin.com/in/ravinder-singh-9b1147292</a></li>
                    </ul>
                </div>
                    
                <div className="footer-newsletter">
                    <h3 className="footer-column-title">Get the latest information</h3>
                    <form className="email-input-wrapper" onSubmit={handleSubmit}>
                    <input 
                        type="email" 
                        placeholder="Email Address" 
                        className="email-input" 
                        aria-label="Email Address"
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        required 
                    />
                    <button type="submit" className="submit-button" aria-label="Subscribe">
                        <img src={EmailAddressContactIcon} alt="Send" className="send-icon" />
                    </button>
                    </form>
                </div>
                </div>

                <div className="footer-bottom">
                <p>Copyright© 2025 Ravinder Singh. All Rights Reserved.</p>
                <div className="footer-bottom-links">
                    <a href="/terms">User Terms & Conditions</a>
                    <a href="/privacy">Privacy Policy</a>
                </div>
                </div>
            </footer>
        </section>
      </>
    );
};

//==================================================================
// --- MAIN PORTFOLIO COMPONENT ---
//==================================================================

const IntegratedPortfolio = () => {
  return (
    <>
      <style>{`
        /* --- Global Styles & Font --- */
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&family=Urbanist:wght@700;900&display=swap');

        html {
          scroll-behavior: smooth;
        }

        body {
          margin: 0;
          font-family: 'Poppins', sans-serif;
          overflow-x: hidden;
          background-color: #FFFFFF; /* Default background */
        }
      `}</style>
      
      <main>
        <HomePage />
        <AboutPage />
        <PortfolioResume />
        <PortfolioProjects />
        <AchievementsPage />
        <ContactPage />
      </main>
    </>
  );
};

export default IntegratedPortfolio;